import styled from 'styled-components';

export const PlayerContainer = styled.div`
    width: 100%;
    height: 100%;
    background: black;
    position: relative;
    overflow: hidden;
`;

PlayerContainer.displayName = 'PlayerContainer';

export const VideoContainer = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    iframe {
        opacity: 0 !important;
    }
    .player-embedded-ui iframe {
        opacity: 1 !important;
    }
`;

VideoContainer.displayName = 'VideoContainer';

interface IPlayerUI {
    isEmbeddedAdUiShown?: boolean;
}

export const PlayerUI = styled.div<IPlayerUI>`
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    pointer-events: ${(props) => (props.isEmbeddedAdUiShown ? 'none' : 'auto')};
`;

PlayerUI.displayName = 'PlayerUI';
